import React from 'react';
import Chart from 'react-apexcharts';
/** Components Import */
import Section from '../../Components/Section';
import Card from '../../Components/Card_wrap';
import AuthGroupButton from '../../Components/Button_Auth_Group';
import DatePicker from '../../Components/Datepicker_Basic';
import BasicButton from '../../Components/Button_Basic';
import Input from '../../Components/Input_Basic';
import FormGroup from '../../Components/Form_Group';
import CardH3 from '../../Components/Card_H3';
import GridModal from '../../Components/Modal_Grid';
/** Ag-grid Import */
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-alpine.css';
import { AgGridReact } from 'ag-grid-react';
import GridFunctions from '../../Services/agGrid/ag-Grid-functions';

function DB10030(props) {
    React.useEffect(() => {
        document.title = '납기스케줄현황';

        const element = document.getElementById('topbar');
        element.innerHTML =
            '<h1>' +
            "<span class='bullet'>" +
            '</span>' +
            "<strong class='depth-1'>" +
            '대시보드관리' +
            '	</strong>' +
            "<span class='divider' >" +
            '</span>' +
            "<strong'>납기스케줄현황</strong>" +
            '</h1>';
    }, []);
    const gridRef = React.useRef();

    const columnDefs = [
        // {
        //   field: "no",
        //   headerName: "No",
        //   minWidth: 110,
        //   headerCheckboxSelection: true,
        //   checkboxSelection: true,
        // },
        //주문번호
        {
            field: 'soNo',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoNo' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //주문일자
        {
            field: 'soDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDate' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //거래처명
        {
            field: 'custNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_CustNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        //품목명
        {
            field: 'itemNm',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_ItemNm' && f.lanType === 'COL')[0].lanName
                    : '',
        },
        {
            field: 'soDueDt',
            headerName:
                props.lanData.length > 0
                    ? props.lanData.filter((f) => f.lanId === 'Col_SoDueDt' && f.lanType === 'COL')[0].lanName
                    : '', //납기일
            minWidth: 130,
            suppressMovable: true,
        },
    ];

    const onCellClicked = (e) => {
        const selected = e.data;
        props.setProcessCdCheck(true);
        props.setSaveSoNo(selected.soNo);
        props.setSaveItemCd(selected.itemCd);
        props.GetSoNoData(selected.soNo, selected.itemCd, selected.soDueDt);
    };

    return (
        <div
            style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-evenly',
                alignItems: 'center',
            }}
        >
            <div style={{ width: '100%' }}>
                <Section />
                <Card
                    wrapStyle={{
                        display: 'flex',
                        justifyContent: 'space-between',
                    }}
                >
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                        }}
                    >
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginRight: '5px' }}
                            selected={props.startDate1}
                            onChange={(e) => {
                                props.setStartDate1(e);
                            }}
                        />
                        ~
                        <DatePicker
                            className={'datepicker-custom-input'}
                            style={{ width: '120px', marginLeft: '5px' }}
                            selected={props.endDate}
                            onChange={(e) => {
                                props.setEndDate(e);
                            }}
                        />
                    </div>
                    <div
                        style={{
                            display: 'flex',
                            alignItems: 'space-between',
                        }}
                    >
                        <AuthGroupButton
                            pageName="PM10010"
                            target="G01"
                            refreshFunc={() => {}}
                            selectFunc={() => {
                                props.Init();
                            }}
                        />
                    </div>
                </Card>
                <Section />
                <div className="ag-theme-alpine no-scroll" style={{ width: '100%', height: '770px' }}>
                    <AgGridReact
                        ref={gridRef}
                        animateRows={true}
                        columnDefs={columnDefs}
                        defaultColDef={{
                            flex: 1,
                            minWidth: 150,
                            editable: false,
                            resizable: true,
                            sortable: true,
                            filter: true,
                            floatingFilter: true,
                        }}
                        onCellValueChanged={(e) =>
                            GridFunctions.onCellValueChanged(e, gridRef, props.setChangedRowData)
                        }
                        rowData={props.rowData}
                        onSelectionChanged={() => GridFunctions.onSelectionChanged(gridRef, props.setSelectedRowData)}
                        onCellClicked={onCellClicked}
                    />
                </div>
            </div>
        </div>
    );
}

export default DB10030;
